module.exports = __webpack_public_path__ + "media/components/content_header/static/wave-56ebd9d3b5ebbf19b8e6b5de23f9a268.png";